import axios from 'axios';

export default {

    setupURL: (url) => {
        axios.defaults.baseURL = url;
    },

    setupInterceptors: () => {
        // Permet d'ajouter le token d'authentification aux requêtes avant qu'elles soient envoyés
        axios.interceptors.request.use(config => {

            var user = localStorage.getItem('utilisateur');

            if (user) {
                config.headers.common['Authorization'] = `Bearer ${JSON.parse(user).token}`;
            }

            return config;
        });

        // Gestion des erreurs
        axios.interceptors.response.use(null, error => {
            if (error.response && error.response.status === 401 && window.location.pathname !== '/login') {
                localStorage.removeItem('utilisateur');
            }

            return Promise.reject(error);
        });
    },

    transformRequestOptions: (params) => {
        let options = '';
        for (const key in params) {
            if (params[key]) {
                if (typeof params[key] !== 'object') {
                    options += `${key}=${params[key]}&`;
                } else if (typeof params[key] === 'object' && params[key].length) {

                    for (let i = 0; i < params[key].length; i++) {
                        options += `${key}=${params[key][i]}&`;
                    }
                    //params[key].forEach(el => {
                    //    options += `${key}=${el}&`;
                    //});
                }
            }
        }
        return options ? options.slice(0, -1) : options;
    }
};